import config from './../../config'

const mocks = {}

if (config.apiMock) {
    mocks.AccommodationsDataApiMock = require('./AccommodationsDataApiMock')
    mocks.GuestsSatisfactionDataApiMock = require('./GuestsSatisfactionDataApiMock')
    mocks.TouristSourceDataApiMock = require('./TouristSourceDataApiMock')
    // add mocks here
}

export default mocks;



// WEBPACK FOOTER //
// ./src/sources/mocks/index.js